<template>
    <plain-layout class="insurance-plans" :isPlain="true" :showTerms="false">
        <common-content-spacer height="medium">
            <common-page-header :heading="pageTitle" size="minor"></common-page-header>

            <common-page-plain>
                <common-content-spacer height="medium">
                    <ancillary-service-tests-table
                        :ancillaryServices="ancillaryServices"
                        :prefillValues="prefillValues"
                        :showHeader="false"
                        @ancillary-selection-save="saveChanges"
                    ></ancillary-service-tests-table>
                </common-content-spacer>
            </common-page-plain>
        </common-content-spacer>
    </plain-layout>
</template>

<script>
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import PageWithElementsMixin from 'mixins/PageWithElementsMixin'
    import PlainLayout from 'components/layouts/PlainLayout'
    import AncillaryServiceTestsTable from 'components/page-elements/ancillary-service-tests/AncillaryServiceTestsTable'
    import FacilityServicesAPI from 'api/FacilityServicesAPI'

    export default {
        mixins: [PageWithTitleMixin, PageWithElementsMixin],

        components: {
            PlainLayout,
            AncillaryServiceTestsTable,
        },

        data() {
            return {
                ancillaryServices: [],
                isLoading: false,
                prefillValues: [],
            }
        },

        computed: {
            pageTitle() {
                return this.$t('pages.practice.profile.titles.practice_profile', {
                    practiceName: this.$route.query.practiceName ? this.$route.query.practiceName : this.$auth.getPractice().name,
                })
            },

            pageSubTitle() {
                return this.$t('pages.practice.insurance.titles.insurance_plans_accepted')
            },
        },

        methods: {
            saveChanges(value) {
                const query = {
                    practiceLocationId: this.$route.query.practiceLocationId,
                    practiceType: this.$route.query.practiceType,
                    practiceId: this.$route.query.practiceId,
                    insurancePlanId: this.$route.query.insurancePlanId,
                    referralTests: value.map((item) => item.id),
                }
                this.$router.push({
                    name: `ehr.referrals.new.make`,
                    query: query,
                    params: {
                        existingReferral: this.existingReferral,
                    },
                })
            },

            loadAncillary() {
                const query = {
                    practiceLocationId: this.$route.query.practiceLocationId,
                    practiceId: this.$route.query.practiceId,
                }
                FacilityServicesAPI.getFacilityServiceGroups(query, [
                    'id',
                    'name',
                    'facilityServiceTypes(id,name,facilityServiceTypesGroups(id,name,typeId,facilityServiceTypesSubgroups(id,name,facilityServiceTests(id,name))))',
                ]).then((response) => {
                    this.ancillaryServices = response.filter((serviceType) => {
                        serviceType.facilityServiceTypes = serviceType.facilityServiceTypes.filter(
                            (service) => service.facilityServiceTypesGroups.length,
                        )
                        serviceType.facilityServiceTypes.map((item) => {
                            item.expanded = false
                        })
                        return serviceType.facilityServiceTypes.some((service) => service.facilityServiceTypesGroups.length)
                    })

                    if (this.$route.query.testIds) {
                        this.setPrefillValues()
                    }
                })
            },

            setPrefillValues() {
                const testIds = this.$route.query.testIds
                    .toString()
                    .split(',')
                    .map((item) => Number(item))
                const checkedValues = []

                this.ancillaryServices.forEach((type) => {
                    type.facilityServiceTypes.forEach((service) => {
                        service.facilityServiceTypesGroups.forEach((group) => {
                            group.facilityServiceTypesSubgroups.forEach((subGroup) => {
                                subGroup.facilityServiceTests.forEach((test) => {
                                    if (testIds.includes(test.id)) {
                                        checkedValues.push(test)
                                        service.expanded = true
                                    }
                                })
                            })
                        })
                    })
                })

                this.prefillValues = checkedValues
            },
        },

        mounted() {
            this.loadAncillary()
        },
    }
</script>

<style lang="scss" scoped>
    .insurance-plans {
        &__back-button {
            .icon {
                margin-top: 10px;
            }
        }
    }
</style>
